import { PlayerNumberTable } from '../../../jscaip/PlayerNumberTable';
import { CheckersControlHeuristic } from './CheckersControlHeuristic';
export class CheckersControlPlusDominationHeuristic extends CheckersControlHeuristic {
    getMetrics(node, config) {
        const controlValue = this.getControlScore(node, config);
        const dominatingPiecesCount = this.getDominatedPieceScore(node);
        return controlValue.concat(dominatingPiecesCount);
    }
    getDominatedPieceScore(node) {
        const dominatedPieces = PlayerNumberTable.of([0], [0]);
        const state = node.gameState;
        const width = state.getWidth();
        const height = state.getHeight();
        for (let y = 0; y < height; y++) {
            for (let x = 0; x < width; x++) {
                const square = state.getPieceAtXY(x, y);
                if (square.getStackSize() > 0) {
                    const stackSize = square.getStackSize();
                    let pieceIndex = 0;
                    const commander = square.getCommander().player;
                    while (pieceIndex < stackSize && square.get(pieceIndex).player === commander) {
                        pieceIndex++;
                    }
                    dominatedPieces.add(commander, 0, pieceIndex);
                }
            }
        }
        return dominatedPieces;
    }
}
